
/**
 * Created by nijin on 22/12/16.
 */
import {Component, OnInit, Output, EventEmitter, OnDestroy, Input, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {WizardBaseContentComponent} from '../../things/shared/wizard/wiz-base.component';
import {SchemaService} from '../schema.service';
import {Schema} from '../model/schema.model';
import {GlobalService} from '../../global/global.service';
import {AuthService} from '../../auth/auth.service';

@Component({
  selector: 'nuc-choose-schema',
  templateUrl: './choose-schema.component.html',
  styleUrls: ['./choose-schema.component.scss']
})
export class ChooseSchemaComponent extends WizardBaseContentComponent implements OnInit, OnDestroy {
  predefinedSchemaList = [];
  isLoading = true;
  customSchemaLoader = true;
  schemaCategoryList = [];
  customSchemaList = [];
  schemaForm: FormGroup ;
  isFromScratch = false;
  isValidState = true;
  isCatLoading = true;
  totalCount: number;
  pageSize = 12;
  currentPage = 1;

  @Input()isMobileApp = false;
  @Output() changeStep = new EventEmitter<any>();
  @ViewChild('preview') previewPopup;
  previewSchema = {};
  constructor(private fb: FormBuilder,
              private schemaService: SchemaService,
              private globalService: GlobalService,
              private authService: AuthService
  ) {
    super();
  }
  ngOnInit() {
    this.init();
    this.buildForm();
  }

  get nextPage() {
    return this.currentPage * this.pageSize <= this.totalCount;
  }


  buildForm() {
    this.schemaForm = this.fb.group({
      'selectedSchema': ['', [
        Validators.required,
      ]
      ]});
  }

  setEmptyTemplate() {
    this.schemaForm.reset();
    this.isFromScratch = true;
    this.schemaService.setSelectedSchema(new Schema(this.authService.getCurrentAccount().id, false));
    this.changeStep.emit();
  }
  valueChanged(value) {
    this.isFromScratch = false;
    this.schemaForm.controls['selectedSchema'].setValue(value);

  }
  canMoveForward() {
    return this.schemaForm.valid && (this.customSchemaList.length > 0 ||
      this.predefinedSchemaList.length > 0) || this.isFromScratch;
  }
  onValidState(subject, nextStep) {
    this.isValidState = true;
    this.isFromScratch = false;
    if (this.schemaForm.valid) {
      this.schemaService.setSelectedSchema(this.schemaForm.controls['selectedSchema'].value);
    }
    if (subject && nextStep) {
      subject.next(nextStep);
    }}
  onInvalidState() {
    this.isValidState = false;
  }
  init() {
    this.getCustomSchema(this.currentPage);
    this.getPredefinedSchema();

    this.globalService.getConfigDataByType(this.globalService.SCHEMA_CATEGORY)
      .subscribe((response) => {
        this.schemaCategoryList = response.items;
        if (this.isMobileApp) {
          let cat = this.schemaCategoryList.filter((category) => {return category.id === 11; })[0];
          this.schemaCategoryList.splice(this.schemaCategoryList.indexOf(cat), 1);
          this.schemaCategoryList.unshift(cat);
        }

        this.isCatLoading = false; });
  }

  getCustomSchema(page) {
    this.customSchemaLoader = true;
    this.schemaService.getCustomSchemaList({page:page, "page-size": this.pageSize})
      .subscribe((data) => {
          this.customSchemaList.push.apply(this.customSchemaList, data.items);
          this.customSchemaLoader = false;
          this.totalCount = data.count;
        },
        (error) => {this.customSchemaLoader = false; });
  }
  getPredefinedSchema() {
    this.schemaService.getPredefinedSchemaList()
      .subscribe((data) => {
          this.predefinedSchemaList = data.items;
          this.isLoading = false;
          if (this.isMobileApp) {
            let mobileSchema = this.predefinedSchemaList.filter((schema) => {
              return schema.id === 6;
            })[0];
            this.schemaForm.setValue({selectedSchema: mobileSchema});
          }
        },
        (error) => { });
  }

  previewSchemaData(schema) {
    this.previewSchema = schema;
    this.previewPopup.open();
  }

  ngOnDestroy() {

  }
  loadMoreSchema() {
    if(this.nextPage) {
      this.currentPage++;
      this.getCustomSchema(this.currentPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/schema/edit-schema/choose-schema.component.ts